import React from "react";
import ProblemFallback from "src/react/components/problem-fallback";

export default function Oops() {
  return <ProblemFallback title="Oops, something's not quite right..." />;
}
